import React, { FC } from 'react';

import { Box, Stack } from '@mui/material';
import { FormikProps } from 'formik';

import {
  AdminAllowanceNames,
  AllowancesNames,
  currency,
  ILongTermContractModel,
} from '@pharmaplan/common';

import RequestContractDetailsCard from '../../SelfService/ServiceWorkshiftDetails/RequestContractModal/RequestContractDetails/RequestContractDetailCard';
import LongShiftCardDetails from '../../SelfService/PharmacistProfile/LongShiftDistributionModal/LongShiftCardDetails';
import genericClasses from '../../../theme/GenericClasses';
import CustomTextField from '../CustomTextField';
import strings from '../../../localization';

import styles from './styles';

type PharmacyEvent = {
  longTermShiftContract: ILongTermContractModel;
  favorite?: boolean;
  logoImage: string;
  pharmacyName: string;
  startDate: string;
  softwareName: string;
};

type PharmacistEvent = {
  firstName?: string;
  lastName?: string;
  name?: string;
  profilePicture: string | null;
  postalCode: string;
  longTermShiftContract: ILongTermContractModel;
};

interface ILongContractCard {
  formik: FormikProps<any>;
  successAction: string;
  event: PharmacyEvent | PharmacistEvent;
  isBooked?: boolean;
  showPromo?: boolean;
}

// FULL-SERVICE POSTED CONTRACTS OMIT THE PHARMACY NAME, SO CHECK THE KEY RATHER THAN ITS VALUE
const isPharmacyEvent = (
  event: PharmacyEvent | PharmacistEvent,
): event is PharmacyEvent =>
  !!event && 'pharmacyName' in event;

const LongContractCard: FC<ILongContractCard> = ({
  formik,
  successAction,
  event,
  isBooked,
  showPromo,
}) =>
  (
    <Stack>
      {isPharmacyEvent(event) ? (
        <RequestContractDetailsCard
          successAction={successAction}
          isBooked={isBooked}
          event={event}
        />
      ) : (
        <LongShiftCardDetails
          isBooked={isBooked}
          customContainerStyle={styles.zeroMargin}
          event={event}
          successAction={successAction}
        />
      )}
      <Box sx={[styles.fieldContainer, showPromo ? styles.promoField : {}]}>
        <CustomTextField
          name={AllowancesNames.weekDayPaidHourlyRate}
          customLabelStyle={styles.labelStyle}
          label={strings.weekdayHourlyRate}
          formik={formik}
          placeholder={' '}
          suffix={currency}
          disabled
          horizontal
        />
        <CustomTextField
          name={AllowancesNames.weekendPaidHourlyRate}
          customLabelStyle={styles.labelStyle}
          label={strings.weekendHourlyRate}
          placeholder={' '}
          suffix={currency}
          disabled
          formik={formik}
          horizontal
        />
        {showPromo && (
        <CustomTextField
          name={AdminAllowanceNames.promoHourlyRate}
          customLabelStyle={styles.labelStyle}
          label={strings.promoHourlyRate}
          placeholder={' '}
          suffix={currency}
          disabled
          formik={formik}
          horizontal
        />
        )}
      </Box>

      <CustomTextField
        disabled
        formik={formik}
        placeholder=" "
        label={strings.allowances}
        name="allowanceNotes"
        multiline
        maxLength={200}
        customClass={genericClasses.borderNoneTextField}
      />

      {!!formik.values?.proposedAllowance && (
      <CustomTextField
        disabled
        formik={formik}
        placeholder=" "
        label={strings.proposedAllowances}
        name="proposedAllowance"
        multiline
        maxLength={200}
        customClass={genericClasses.borderNoneTextField}
      />
      )}
    </Stack>
  );

export default LongContractCard;
